import { Link } from "react-router-dom";
import { Phone, Menu, X, Sparkles } from "lucide-react";
import { useState } from "react";
import { BUSINESS } from "../data/business";

const navItems = [
  { label: "Home", href: "/" },
  { label: "Services", href: "/services" },
  { label: "Commercial", href: "/commercial-cleaning" },
  { label: "Pricing", href: "/pricing" },
  { label: "Reviews", href: "/#reviews" },
  { label: "FAQ", href: "/faq" },
  { label: "Service Areas", href: "/#areas" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="glass-nav sticky top-0 z-50" data-testid="site-header">
      <div className="container-ss flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-center gap-2.5" data-testid="logo-link">
          {BUSINESS.logoSrc ? (
            <img
              src={BUSINESS.logoSrc}
              alt="S.S. Cleaning Solutions logo"
              width="56"
              height="56"
              className="h-11 md:h-14 w-auto object-contain"
            />
          ) : (
            <>
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-2xl bg-[#0B1A3F] text-white shadow-sm">
                <Sparkles size={18} />
              </span>
              <span className="font-display font-bold text-lg md:text-xl text-[#0B1A3F] leading-tight tracking-tight">
                S.S. Cleaning <span className="text-[#1E3A8A]">Solutions</span>
              </span>
            </>
          )}
        </Link>

        <nav className="hidden xl:flex items-center gap-6">
          {navItems.map((n) => (
            <a
              key={n.label}
              href={n.href}
              className="text-sm font-medium text-slate-700 hover:text-[#1E3A8A] transition-colors"
              data-testid={`nav-${n.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a href={BUSINESS.phoneHref} className="btn-outline !py-2 !px-4 text-sm" data-testid="header-call-btn">
            <Phone size={16} /> {BUSINESS.phone}
          </a>
          <a href="/#quote" className="btn-primary !py-2 !px-5 text-sm" data-testid="header-quote-btn">
            Request a Free Quote
          </a>
        </div>

        <button
          aria-label="Open menu"
          className="md:hidden inline-flex items-center justify-center h-10 w-10 rounded-full border border-slate-200 text-slate-700"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>

        <button
          aria-label="Open menu"
          className="hidden md:inline-flex xl:hidden items-center justify-center h-10 w-10 rounded-full border border-slate-200 text-slate-700"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="xl:hidden border-t border-slate-100 bg-white" data-testid="mobile-menu">
          <div className="container-ss py-4 flex flex-col gap-3">
            {navItems.map((n) => (
              <a
                key={n.label}
                href={n.href}
                onClick={() => setOpen(false)}
                className="text-base py-2 text-slate-700 hover:text-[#1E3A8A]"
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              >
                {n.label}
              </a>
            ))}
            <div className="flex flex-col gap-2 pt-2">
              <a href={BUSINESS.phoneHref} className="btn-outline justify-center">
                <Phone size={16} /> Call {BUSINESS.phone}
              </a>
              <a href="/#quote" onClick={() => setOpen(false)} className="btn-primary justify-center">
                Request a Free Quote
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
